export default "__VITE_ASSET__CVXrqsuW__"